import { VueConstructor } from 'vue'
import FfpStoreSales from './FfpStoreSales.vue'
import FfpAgentSales from './FfpAgentSales.vue'
import { ServicePlanType } from '@/types/generated/graphql'

export const components: { [key in ServicePlanType]: VueConstructor<Vue> } = {
  StoreSales: FfpStoreSales,
  AgentSales: FfpAgentSales,
  Other: FfpStoreSales,
}
